import { Outlet, useSearchParams, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import TaskDetailPanel from "../TaskDetailPanel";
import { useData } from "../../contexts/DataContext";
import { useEffect, useState } from "react";

export default function AppLayout() {
  const { ready, openTaskId, setOpenTaskId } = useData();
  const [searchParams, setSearchParams] = useSearchParams();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const t = searchParams.get("task");
    if (t) {
      setOpenTaskId(t);
      searchParams.delete("task");
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setOpenTaskId, setSearchParams]);

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  if (!ready) {
    return (
      <div className="h-screen flex items-center justify-center bg-background">
        <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" data-testid="data-loading-spinner" />
      </div>
    );
  }

  return (
    <div className="w-full h-screen overflow-hidden flex bg-background" data-testid="app-layout">
      {mobileOpen && (
        <div data-testid="sidebar-backdrop" className="fixed inset-0 bg-black/40 z-30 md:hidden" onClick={() => setMobileOpen(false)} />
      )}
      <Sidebar mobileOpen={mobileOpen} collapsed={collapsed} onClose={() => setMobileOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <Topbar onMenuClick={() => setMobileOpen(true)} onToggleCollapse={() => setCollapsed((c) => !c)} />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
      {openTaskId && <TaskDetailPanel taskId={openTaskId} onClose={() => setOpenTaskId(null)} />}
    </div>
  );
}
